<template>
  <div>
    <el-dialog :visible.sync="showUserAuth">
      <div class="content">
        <div class="button" @click="toUserAuth"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    showUserAuth: {
      get() {
        return this.$store.state.user.showUserAuth;
      },
      set(val) {
        if (val) {
          this.onShowUserAuth();
        } else {
          this.onHideUserAuth();
        }
      },
    },
  },
  methods: {
    ...mapActions("user", ["onHideUserAuth", "onShowUserAuth"]),
    toUserAuth() {
      this.$router.push({
        name: "UserAuth",
      });
      this.onHideUserAuth();
    },
  },
};
</script>

<style scoped lang="scss">
.content{
  width: 460px;
  height: 312px;
  background-image: url(~@/assets/image/home/gerenshiming/gerenshiming_bg.webp);
  background-size: 100% auto;
  position: relative;
  .button{
    width: 120px;
    height: 34px;
    position: absolute;
    left: 170px;
    bottom: 30px;
    cursor: pointer;
    &:active{
      background-color: rgba($color: #fff, $alpha: .3);
    }
  }

}

</style>
